"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Employee = _interopRequireDefault(require("../model/Employee"));
var _Message = _interopRequireDefault(require("../model/Message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Employee service.
* @module api/EmployeeApi
* @version 3.0
*/
var EmployeeApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new EmployeeApi. 
  * @alias module:api/EmployeeApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function EmployeeApi(apiClient) {
    _classCallCheck(this, EmployeeApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Get an Employee of the Operator
   * Get the details of an Employee of the Operator
   * @param {Number} employeeId ID of the employee
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Employee} and HTTP response
   */
  return _createClass(EmployeeApi, [{
    key: "getOperatorEmployeeWithHttpInfo",
    value: function getOperatorEmployeeWithHttpInfo(employeeId) {
      var postBody = null;
      // verify the required parameter 'employeeId' is set
      if (employeeId === undefined || employeeId === null) {
        throw new Error("Missing the required parameter 'employeeId' when calling getOperatorEmployee");
      }
      var pathParams = {
        'employeeId': employeeId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Employee["default"];
      return this.apiClient.callApi('/employees/{employeeId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get an Employee of the Operator
     * Get the details of an Employee of the Operator
     * @param {Number} employeeId ID of the employee
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Employee}
     */
  }, {
    key: "getOperatorEmployee",
    value: function getOperatorEmployee(employeeId) {
      return this.getOperatorEmployeeWithHttpInfo(employeeId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify an employee.
     * Modify the details of the Employee.
     * @param {Number} employeeId ID of the employee
     * @param {module:model/Employee} employee Employee details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Employee} and HTTP response
     */
  }, {
    key: "modifyEmployeeWithHttpInfo",
    value: function modifyEmployeeWithHttpInfo(employeeId, employee) {
      var postBody = employee;
      // verify the required parameter 'employeeId' is set
      if (employeeId === undefined || employeeId === null) {
        throw new Error("Missing the required parameter 'employeeId' when calling modifyEmployee");
      }
      // verify the required parameter 'employee' is set
      if (employee === undefined || employee === null) {
        throw new Error("Missing the required parameter 'employee' when calling modifyEmployee");
      }
      var pathParams = {
        'employeeId': employeeId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Employee["default"];
      return this.apiClient.callApi('/employees/{employeeId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify an employee.
     * Modify the details of the Employee.
     * @param {Number} employeeId ID of the employee
     * @param {module:model/Employee} employee Employee details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Employee}
     */
  }, {
    key: "modifyEmployee",
    value: function modifyEmployee(employeeId, employee) {
      return this.modifyEmployeeWithHttpInfo(employeeId, employee).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();